import { Image, ImageProps } from '@chakra-ui/react'
import svg from 'assets/artwork/startup.svg'
import { forwardRef } from 'react'

export const Startup = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    return <Image alt="a person using circleloop" {...props} ref={ref} src={svg} />
})

Startup.displayName = 'Startup'
